import React, { Component } from 'react'
import { Text } from 'react-localizer'
import { Alert, Col, Grid, Row } from 'react-bootstrap'

class ResultsContainer extends Component {

  constructor (props) {
    super(props)
    this.state = {
      pfToEarn: parseInt(props.choices.pfToEarn, 10),
      maxPf: parseInt(props.choices.maxPf, 10),
      totalPfPut: parseInt(props.choices.totalPfPut, 10),
      pfToOvertake: parseInt(props.choices.pfToOvertake, 10),
      theArcBonus: parseFloat(props.choices.theArcBonus) / 100,
      ownPfLaid: parseInt(props.choices.ownPfLaid, 10),
      label: props.choices.label
    }
  }

  /**
   * When composant receive new params
   * @param nextProps
   */
  componentWillReceiveProps (nextProps) {
    this.setState({
      pfToEarn: parseInt(nextProps.choices.pfToEarn, 10),
      maxPf: parseInt(nextProps.choices.maxPf, 10),
      totalPfPut: parseInt(nextProps.choices.totalPfPut, 10),
      pfToOvertake: parseInt(nextProps.choices.pfToOvertake, 10),
      theArcBonus: parseFloat(nextProps.choices.theArcBonus) / 100,
      ownPfLaid: parseInt(nextProps.choices.ownPfLaid, 10),
      label: nextProps.choices.label
    })
  }

  /**
   * Calculates all the Data
   */
  calculatesResults () {

    const pfAddedByOtherPlayers = this.state.totalPfPut - this.state.pfToOvertake - this.state.ownPfLaid
    const pfFree = this.state.maxPf - this.state.totalPfPut
    const pfFreeWithoutMe = pfFree + this.state.ownPfLaid

    const isPossibleGeneral = this.state.maxPf >= this.state.totalPfPut
    const isPossibleTotalPutValidated = this.state.totalPfPut >= this.state.pfToOvertake + this.state.ownPfLaid
    const isPossibleToOvertake = (this.state.maxPf - this.state.pfToOvertake - pfAddedByOtherPlayers) > this.state.pfToOvertake
    const isPossible = isPossibleGeneral && isPossibleToOvertake && isPossibleTotalPutValidated

    // Warn "this is impossible"
    if (!isPossible) {
      return (<Row className="show-grid" bsStyle="warning">
        <Col xs={12}>
          <Alert bsStyle="danger"><Text>lockThePlace.impossible</Text></Alert>
        </Col>
      </Row>)
    }

    let toPut = Math.ceil(((pfFreeWithoutMe - this.state.pfToOvertake) / 2) + this.state.pfToOvertake - this.state.ownPfLaid)

    let balanceSheet = Math.ceil(this.state.pfToEarn * this.state.theArcBonus - toPut - this.state.ownPfLaid)
    const balanceSheetLabel =
      balanceSheet > 0 ? <Text variables={{balanceSheet: balanceSheet}}>lockThePlace.win</Text> :
        balanceSheet < 0 ? <Text variables={{balanceSheet: Math.abs(balanceSheet)}}>lockThePlace.lost</Text> : ''

    // if toPut is < 0, we transfer this negative 'toPut' to the balanceSheet :
    if (toPut < 0) {
      balanceSheet += toPut
      toPut = 0
    }

    let columnWeight = 6
    let labelRow = ''

    // display label only if not null
    if (this.state.label) {
      columnWeight = 4
      labelRow = (<Col xs={columnWeight}>
        <Alert bsStyle="info">{this.state.label}</Alert>
      </Col>)
    }

    return (<Row className="show-grid">
      {labelRow}
      <Col xs={columnWeight}>
        <Alert bsStyle="info"><Text variables={{toPut: toPut}}>lockThePlace.neededToLock</Text></Alert>
      </Col>
      <Col xs={columnWeight}>
        <Alert bsStyle={balanceSheet > 0 ? 'success' : 'danger'}>
          <Text variables={{balanceSheet: Math.abs(balanceSheet)}}>lockThePlace.balanceSheet</Text> {balanceSheetLabel}
        </Alert>
      </Col>
    </Row>)

  }

  render () {
    return (<div>
      <Grid>
        {this.calculatesResults()}
      </Grid>
    </div>)
  }
}

export default ResultsContainer



// WEBPACK FOOTER //
// ./src/components/LockThePlace/LockThePlaceResults.js